/** Query flag value for {@link readPageSkeletonPreviewQueryFlag}. */
export const PAGE_SKELETON_PREVIEW_QUERY_PARAM = 'pageSkeletonPreview';

/**
 * Returns true when `?pageSkeletonPreview=1` is present so E2E and manual QA can
 * exercise page skeleton layout/a11y without waiting for a slow enter-time API.
 * Wired on Ship From/To, Package, Service, Review & Pay, and Get Labels.
 */
export function readPageSkeletonPreviewQueryFlag(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    new URLSearchParams(window.location.search).get(PAGE_SKELETON_PREVIEW_QUERY_PARAM) === '1'
  );
}
